import { render, staticRenderFns } from "./Sofascore2.vue?vue&type=template&id=35b89778&scoped=true&"
import script from "./Sofascore2.vue?vue&type=script&lang=js&"
export * from "./Sofascore2.vue?vue&type=script&lang=js&"
import style0 from "./Sofascore2.vue?vue&type=style&index=0&id=35b89778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b89778",
  null
  
)

export default component.exports